import PrintModalView from "../../app/angularjs/events/common/printModal.html";
import DocumentsModalView from "../../app/angularjs/common/modal/documentsModal.html";


angular.module("app")

.factory("generateDocumentService", ['$injector', 'logService', function ($injector, logService) {
    var service = {
        document: function (options) {
            var $uibModal = $injector.get("$uibModal");
            let $modalInstance = $uibModal.open({
                animation: true,
                template: PrintModalView,
                controller: 'ModalGenerateDocumentCtrl',
                size: 'extra-lg',
                resolve: {
                    options: function () { logService.debug(options); return options; }
                }
            });           

            $modalInstance.result.then(function (data) {
                options.onAccept(data); //Devolvemos el control al controlador que lo invoca
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
            });

        },
        documentNew: function (options) {
            /*
             * EJEMPLOS DE PARAMETROS DE ENTRADA
             * añadiendo directamente el codigo del document_type
             * var params = {
                entity_type: "correspondence",
                documents: { codes: ["CORRESPONDENCE"] }
                };
             * var params = {
                entity_type: "correspondence",
                entity_type_id: $stateParams.id, //si estamos en una correspondencia en concreto.
                documents: { codes: ["CORRESPONDENCE_RESPONSE"] }
                }; 
                var params = {
                    entity_type: "events",
                    entity_type_id: $stateParams.id, //si estamos en un evento.
                    documents: { for_event_staff: true } //seran todos los documentos marcados como para staff.
                };
             */
            var $uibModal = $injector.get("$uibModal");

            let $modalInstance = $uibModal.open({
                animation: true,
                template: DocumentsModalView,
                controller: 'ModalDocumentsTypesCtrl',
                size: 'extra-lg',
                resolve: {
                    options: function () { return options; }
                }
            });


            $modalInstance.result.then(function (data) {
                logService.debug(data);
                options.onAccept(data); //Devolvemos el control al controlador que lo invoca
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
            });

        }
    };
    return service;
}])
;